/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState,useRef,useEffect } from 'react';
import { DataGrid ,DeleteConf, UpdateEmployeeModal} from "../../../common";
import uploadItemIcon from '../../../assets/icons/upload-items.svg';
import {ReactComponent as DeleteIcon} from '../../../assets/icons/delete.svg';
import { FaLock } from 'react-icons/fa';
import { userTypes } from '../../../utils/configs';
import { onDownloadXlsFile,parseJwtToken } from '../../../utils/commonFunctions';
import Edit2 from "../../../assets/edit2.svg";
import { APIEndpoint, DFPAPIEndpoint } from '../../../utils/axios';
import searchIcon from '../../../assets/icons/search.svg';
import { useTranslation } from 'react-i18next';
import DOWNLOAD_ICON from "../../../assets/icons/download-master.svg";
import { ToastContainer } from 'react-toastify';
import useToastAssist from '../../../utils/useToastAssist';
import 'react-toastify/dist/ReactToastify.css';
import {RoleModal}  from '../../employees/inner-components/RoleModal';
import CustomSelect from '../../../common/CustomSelect';
import usePermissions from '../../../utils/userPermissions';
import LoadingGIF from '../../../assets/loadingIn.gif';
import HeaderSelectAll from '../../../common/HeaderSelectAll';
const AddEmployeeField = [
  { label: 'User Name', attribute: 'userName', type: 'text',required: true, disabled: false },
  { label: 'Name', attribute: 'name', type: 'text',required: false, disabled: false },
  { label: 'User Type', attribute: 'userType', type: 'select',options:userTypes, disabled: false },
  { label: 'Email', attribute: 'email', type: 'text', disabled: false },
  { label: 'Mobile', attribute: 'mobile', type: 'text', disabled: false },
  { label: 'Address', attribute: 'address', type: 'textarea', disabled: false,rows:4 },
]


export const ManageUserAccountsPage = (props) => {
  const [state, setState] = useState({})
  const tableRef = useRef();
  const { t,ready } = useTranslation();
  const [perPageLimit] = useState(50);
  const [roleModal, setRoleModal] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [remove, setRemove] = useState(false);
  const [buttonStat,setButtonStat]=useState(false);
  const [delPop,setDelPop]=useState(false);
  const [buttonDisable,setButtonDisable]=useState(true);
  const [delConf,setDelConf]=useState(false);
  const [userSelected, setUserSelected] = useState('');
  const [roleNames, setRoleNames] = useState([]);
  const [rolesArray,setRolesArray]=useState([]);
  const [subSelection,setsubSelection] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [ uploadedFile, setUploadedFile ] = useState([])
  const [ uploadFileStatusBlock, setUploadFileStatusBlock ] = useState('');
  const [roleOptions, setRoleOptions] = useState(null);
  const [searchKey, setSearchKey] = useState('');
  const [empSpec] = useState(true);
  const [submitRoles, setSubmitRoles] = useState([]);
  const [editFormFields, setEditFormFields] = useState([...AddEmployeeField]);
  const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });
  const [, setConfirm] = useState('');
  const [show, setShow] = useState(false);
  const [roleItems,setRoleItems]=useState([]);
const [isMoreDirectory,setIsMoreDirectory]=useState(false);
  const [addRoles, setAddRoles] = useState(false);
  const [selectAll,setSelectAll]= useState({isChecked:false,label:"User Name"});
  const [checkbox,setCheckBox]=useState(false);
  const sType = localStorage.getItem('sType');
  const {toastError} = useToastAssist();
  

  const { hasPermission: viewUserAccnt } = usePermissions('view', 'administration.user-accounts');
  const { hasPermission: viewUserAcccntDetails } = usePermissions('viewDetails', 'administration.user-accounts');
  const { hasPermission: createUserAccnt } = usePermissions('create', 'administration.user-accounts');
  const { hasPermission: editUserAccnt } = usePermissions('edit', 'administration.user-accounts');
  const { hasPermission: uploadUserAccnt } = usePermissions('upload', 'administration.user-accounts');
  const { hasPermission: downloadUserAccnt } = usePermissions('download', 'administration.user-accounts');
  const { hasPermission: deleteUserAccnt } = usePermissions('delete', 'administration.user-accounts');

  const DOMAIN = (sType === 'dfp' ? DFPAPIEndpoint : APIEndpoint);
  const preCompile = {
    roles:t('selectButtons.selRole'),
    clusters:t('selectButtons.selCluster'),
    stores:t('selectButtons.selStore'),
    warehouses:t('selectButtons.selWarehouse'),
    cashdrawers:t('selectButtons.selCashDraw')
  }

  const HeaderCheckBoxRenderer=()=>{
    return (
      <HeaderSelectAll
      checkbox={checkbox}
      selectAll={selectAll}
      setSelectAll={setSelectAll}/>
  );
  }
 const valueGetter=(params)=>{
    const {data } = params;
    if (!data) {
      return '';
    }
    const {idps}=data||[];
    return (
          <><div className='flexRow justifyContentSpaceBetween' style={{width:'100%',maxWidth:'355px',overflow:'auto'}}>
          <div className='sector-container justifyContentFlexStart alignItemsCenter' style={{maxWidth:'200px'}}>{Array.isArray(idps) && idps.length > 0 ? idps.map((key, index) => (
        <span key={index} className={!index?"sector-label-minGrid margSecotInit":"sector-label-minGrid"}>{key}</span>
          )) :null}</div>
       </div>
          </>
    );
  }


  const Columns = [
    { field: 'userName',headerName: 'User Name', tooltipField:'userName',suppressSizeToFit:true, resizable:true,checkboxSelection: checkbox,headerComponentFramework : HeaderCheckBoxRenderer, minWidth: 150,width:180,flex:1, },
    { field: 'userType',headerName: 'User Type',suppressSizeToFit:true, resizable:true,flex:1, maxWidth:120,width:110,minWidth: 100,},
    { field: 'name',headerName: 'Name',suppressSizeToFit:true, resizable:true, minWidth: 215,flex:1 },
    { field: 'email',headerName: 'Email',suppressSizeToFit:true, resizable:true, minWidth: 235,flex:1 },
    { field: 'userDirectories',headerName: 'User Directories',suppressSizeToFit:true,cellRendererFramework:valueGetter, resizable:true, minWidth: 205,flex:1 },
    { field: 'actions',headerName:"Actions",width:180,cellRenderer: ActionComponent,flex:1 },

]


useEffect( () => {
  preCompile.department = t('selectButtons.userSelected');
  preCompile.designation = t('selectButtons.selDesignation');
  preCompile.roles=t('selectButtons.selRole');
    if(!roleNames.length){
    fetchRoles();
    }
}, [ready]);



  React.useEffect(() => {
    if(!delConf||!delPop)return;
    fetchUserAccounts();
  }, [delConf,delPop]);

  React.useEffect( () => {
    refreshTable();
  }, [userSelected,tableRef]);



 React.useEffect(() => {
  if(show){
      const timeId = setTimeout(() => {
      setShow(false);
    setModalFormStatusObj({ text: '' });
    if(modalFormStatusObj.text){
      setDelPop(false);
    }
    }, 3000)
return () => {
      clearTimeout(timeId)
    }
  }
  }, [show]);

    useEffect(() => {
      if(state?.message && state.message?.text){
        toastError(state?.message || state.message?.text);
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);
  const handleReset = () => {
    setState((_) => {
      return { ..._, resetDataSource: !_.resetDataSource };
    })
    let timerId = setTimeout(() => {
      clearTimeout(timerId);

      onClose();
    }, 500)
  }

  function ActionComponent(props){
    if(!props.data || !editUserAccnt) return null
    return (
      <div className='flexRow justifyContentSpaceBetween' style={{gap:"35px",padding:"10px"}}>
        <><img src={Edit2} className="action-Component-items" alt='edit' title='Edit User Account' onClick={e=>onAction(e,"editUserAccount",props.data)}/>
       <FaLock title='Edit User Directories' color='#fff' size={20} style={{cursor:"pointer"}} onClick={e=>onAction(e,"editUserDirectories",props.data)}/></>
      </div>
    )
  }


  const filterData = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    filters: [],
    limit: 10,
    page: 1,
    searchParam: ''
  };

  const fetchUserAccounts = async (page=1, pageSize=50) => {
    filterData.page = page;
    filterData.limit = pageSize;
    filterData.searchParam = searchKey;
    if(!viewUserAcccntDetails)return;
    if(userSelected){
        filterData.filters.push({userType: userSelected});
    }else{
         filterData.filters=[];
    }
    try {
      const res = await APIEndpoint.post('userAccount/process', filterData);
      if(res.count === 0 || res.items.length === 0){
        setCheckBox(false)

      }
      else{
        setCheckBox(true)

      }
        return res;
    } catch (error) {

    }

  }


  const fetchRoles = async() => {
        try {
           const resp = await APIEndpoint.get(`idpConfig/idpNames`);
           if(resp.success && resp.items.length){
           setRolesArray(resp.items);
       const options = [{key: 0, label: preCompile.roles, value: ''}];
      resp.items.filter( (fieldValue, index) => {
        options.push({key: index+1, label: fieldValue, value: fieldValue});
        return fieldValue;
      });
        setRoleNames(options);


       }
           }
            catch (error) {

            }
     }



  const refreshTable = () => {
      userSelected?.name??tableRef.current?.refreshTableHandler(userSelected?.name);
  };


const onAction = async(e, action, row) => {
 if(action==='editUserAccount'){
     try {
      const res = await APIEndpoint.get(`userAccount/${row?.userName}`);
  if (res.success && res?.result){
    const {result}=res;
    setEditFormFields(_prev =>
  _prev.map(field => {
  const updates = {
   userName: { initialValue: result?.userName ?? "", disabled: true },
   name:     { initialValue: result?.name ?? "" },
   userType: { initialValue: result?.userType ?? "" },
   email:    { initialValue: result?.email ?? "" },
   mobile:   { initialValue: result?.mobile ?? "" },
   address:  { initialValue: result?.address ?? "" }
  };
  
  return updates[field.attribute]
   ? { ...field, ...updates[field.attribute] }
   : field;
  })
  );
  
   setState( (_prev) => {
     return { ..._prev, selected: { action: 'editUserAccount',...result } };
   });
  }
        }
         catch (err) {
console.log('error in edit',err)
         }
 }
else{
    if(row.idps && row.idps.length){
        row.idps.forEach(role=>getRoleresArray(role))
    }
 setState( (_prev) => {
        return { ..._prev, selected: { action: 'editUserDirectories',...row } };
      });
  setRoleModal(true);
}
  }

  const onClose = () => {
    setRoleItems([])
    setUploadedFile([]);
     setIsMoreDirectory(false);
    setUploadFileStatusBlock("")
    setState((_prev) => {
      return { ..._prev, selected: false ,resetDataSource:modalFormStatusObj.text && modalFormStatusObj.text?.length>0?!_prev.resetDataSource:_prev.resetDataSource}
    })
    setEditFormFields( _prev => {
      return [...AddEmployeeField] ;
  });
    if(!showUpload){
      setRoleItems([]);
    }
    setRoleModal(false);
    setShowUpload(false);
    setRoleOptions('');
    setConfirm('');
    setShow(true);
    setAddRoles(false)
    setsubSelection("");
    setSubmitRoles([]);
    setModalFormStatusObj({ text: '' });
  }


const cleanPayloadEntries=(body,updated)=>{
    for (var propName in body) {
      if (body[propName] === ''|| body['passwordReset']) {
        delete body[propName];
      }

    }
    return body
}

  const onEditSubmit = async (updated) => {
  setModalFormStatusObj({ text: '' });
    const {selected}=state;
  let body;
if(selected.action==="AddUserAccount" && updated && updated.userType && updated.userName){
  setModalFormStatusObj({ text: '' });
        const storedCreds = localStorage.getItem('login_credentials');
        if (!storedCreds) return;
  
        const parsedCreds = JSON.parse(storedCreds);
        const { data, headers } = parsedCreds || {};
        const tokenResp = await parseJwtToken(data);
  
        if (
          !tokenResp?.userId ||
          !data?.token ||
          !headers?.['x-csrf-token']
        )
          return;
   body={
    "customerId":tokenResp?.userId,
  ...(updated.name!==null?{"name": updated.name}:{}),
    "userName": updated.userName?updated.userName:"",
  "userType": updated.userType
  ? userTypes
      .filter(item => item.value === updated.userType)
      .map(item => ({ name: item.label, id: item.value }))[0]
  : ""
,
    ...(updated.email!==null?{"email": updated.email}:{}),
    ...(updated.mobile!==null?{"mobile": updated.mobile}:{}),
    ...(updated.address!==null?{"address": updated.address}:{}),
}
let payload=cleanPayloadEntries(body);
  try {
          const res = await APIEndpoint.post(`userAccount`, payload);
          if(res.success){
            setModalFormStatusObj({ text: res?.msg||"Sucessfully Added User Account"});
            handleReset();
          }

          }
           catch (error) {
 const errorObj = JSON.parse(error.message);
    setModalFormStatusObj({error:errorObj?.data?.msg||"Something went wrong please try again!"})
           }

}
else{
  setModalFormStatusObj({ error:`Please fill all the required fields*` });
}

if(selected.action==="editUserAccount"){
  setModalFormStatusObj({ text: '' });
   const storedCreds = localStorage.getItem('login_credentials');
        if (!storedCreds) return;
  
        const parsedCreds = JSON.parse(storedCreds);
        const { data, headers } = parsedCreds || {};
        const tokenResp = await parseJwtToken(data);
  
        if (
          !tokenResp?.userId ||
          !data?.token ||
          !headers?.['x-csrf-token']
        )
          return;

  body={
    "audit":selected.audit,
    "dateModified":selected?.dateModified,
    "deleted":selected.deleted,
    "idps":selected.idps,
    "customerId":tokenResp?.userId,
    ...(updated.name!==null?{"name": updated.name}:{name:selected.name??""}),
    "userName": updated.userName??selected.userName,
  "userType": updated?.userType
  ? userTypes
      .filter(item => item.value === updated.userType)
      .map(item => ({ name: item.label, id: item.value }))[0]
  : userTypes
      .filter(item => item.value === selected.userType)
      .map(item => ({ name: item.label, id: item.value }))[0],
    ...(updated.email!==null?{"email": updated.email}:{email:selected.email??""}),
    ...(updated.mobile!==null?{"mobile": updated.mobile}:{mobile:selected.mobile??""}),
    ...(updated.address!==null?{"address": updated.address}:{address:selected.address??""}),
}
try {

  const res = await APIEndpoint.put(`userAccount/${selected.userName}`, body);
  if(res.success){
    setModalFormStatusObj({ text: res?.msg ||"Successfully Updated User Account" });
    handleReset();
  }

  }
   catch (error) {
    const errMsg = JSON.parse(error.message);
    setModalFormStatusObj({error:errMsg?.data?.msg})
   }
}

  }

  const handleResetDelete=()=>{

    let timerId = setTimeout(() => {
      clearTimeout(timerId);
      setButtonStat(false);
    setModalFormStatusObj({ text: '' })
    setState((_) => {
      return { ..._, resetDataSource:  !state.resetDataSource };
    })
    if(selectAll.isChecked){
      setSelectAll((_)=>({..._,isChecked:!_.isChecked}));
    }
    setButtonDisable(true);
    setDelConf(false);
    setDelPop(false);
    }, 1500)
}

const onDeleteEmployee=async(emp)=>{
    const empData= {
       "users": emp
   }
     try {
      setButtonStat(true);
     const res= await APIEndpoint.post(`userAccount/remove`,empData);
    if(res.success){
      setModalFormStatusObj({ text: res.message });

    }
     }
      catch (error) {
        const errMsg=JSON.parse(error.message)
        setModalFormStatusObj({ error: errMsg?.data?.message });
      }
      handleResetDelete();
   }


  const onContinue=()=>{
    setDelConf(true);
  }
  const onChange=(e)=>{
    if(e && rolesArray.length>0){
    let r=rolesArray.find((sc)=>sc.name===e.value)
    setSubmitRoles([...submitRoles,{role: r}])

    }
  }

  const onSearch = (e) => {
      setSearchKey(e.target.value);
  };

  const onUserChange = (e) => {
    setUserSelected(e?.value??"");
  }


  const onAddEmployeeHandler = () => {
    setEditFormFields( _prev => {
    return _prev.map(field=>{
    if(field.attribute==='userType'){
    return {...field,options:userTypes}
    }
    return field;
})
  });

      setState( (_prev) => {
        return { ..._prev, selected: { action: 'AddUserAccount' } };
      });
  }
const onCloseDelete=()=>{
  setDelPop(false);
  setDelConf(false);
}
const onUploadTaxMaster=()=>{
  setShowUpload(true)
}

const onRoleChange=(e)=>{
  if(e.target.value.length>0 &&rolesArray.length>0){
  let r=rolesArray.find((sc)=>sc.name===e.target.value)
  setSubmitRoles([...submitRoles,{role: r}])

  }
}
const onAddRole=(e)=>{
 if( roleOptions){
getRoleresArray(roleOptions);
 setAddRoles(true);
 }

}


const onDownloadItemMaster=async()=>{
  let header={
    'Accept':'text/csv'
  }
      try {
      setIsDownloading(true)
      const res= await DOMAIN.post(`userAccounts/activeUsers`,{},header);
      if(res.status==='scheduled'){

        setTimeout(() => {
          setIsDownloading(true)
          const dowId= DOMAIN.get(`downloads/status/${res.id}`);
          dowId.then((val) => {
            if (val.status === "completed") {
                DOMAIN.get(`downloads/analytics/${val.fileName}${val.fileExtension}`)
                    .then((userAccountDownload) => {
                        const url = window.URL.createObjectURL(new Blob([userAccountDownload]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `${val.fileName}${val.fileExtension}`);
                        document.body.appendChild(link);
                        link.click();
                        setIsDownloading(false);
                    })
                    .catch((error) => {

                        console.error('Error downloading CSV:', error);
                        setIsDownloading(false);
                    });
            }
        });
          }, 8000);
      }

      }
       catch (error) {
        setState((_) => {
          return { ..._,message:{text:error?.data?.message||"Something went wrong!"},};
        })
        setTimeout(() => {
          setState((prevState) => ({
            ...prevState,
            message: null,
          }));
        }, 5000);
         setIsDownloading(false)
       }
    }


const getRoleresArray=(opt)=>{
    setIsMoreDirectory(false);
    if(roleItems && roleItems.length<2){
       setRoleItems(prev => {
        const exists = prev.some(item => item.value === opt);
        if (exists) return prev;
        const newItems = roleNames?.filter(item => item.value === opt);
        return [...prev, ...newItems]});
        resetFields();
    }else{
        setIsMoreDirectory(true);
    }

}

const resetFields=()=>{
 setIsMoreDirectory(false);
  setRoleOptions([]);
}

const onRoleSubmit=async()=>{
    const {selected}=state;
      const body={"idps":roleItems.map(item=>item.value)};
  try {
    const res= await APIEndpoint.post(`userAccount/${selected.userName}/userDirectoryBindings`,body);
    if(res.success){
      setModalFormStatusObj({ text: res.msg||"User Directories updated successfully" });
      handleReset();
    }
    }
     catch (error) {
      setModalFormStatusObj({ error: error?.data?.msg ||"Error" });

     }
}
  const onRemoveEmployee=(employeeId)=>{
    setRemove(true);
    if(employeeId.constructor === Array){
   onDeleteEmployee(employeeId);
    }
  }
  const onDownloadSampleFile = () => {
    onDownloadXlsFile('samples/downloads/UserAccount_Upload_Sample','UserAccount_Upload_Sample')
  }
  const onUploadFileChangeHandler = async (e) => {
    try {
      const file=e.target.files[0];
      setUploadedFile(e.target.files[0]);
      setUploadFileStatusBlock('<p>Please wait while we process your data...</p>');
      const formData = new FormData();
      formData.append('userDirectoryBindings', JSON.stringify(roleItems.map(item=>item.value)||[]));
      formData.append('file', file);
      await APIEndpoint.post('userAccounts/upload', formData);
      setUploadFileStatusBlock('<p>File Imported Successfully.</p>');
      setState((_) => {
        return { ..._, resetDataSource: true };
      })
    } catch (error) {
      e.target.value = null;
      let { status, data } = JSON.parse( error.message );
      let msgHeading = data?.Error || data?.message || error.message;
      msgHeading= msgHeading.includes('status')?`Failed to upload.`:msgHeading;

      let msgContent = "";
      if (status === 400 && data) {
            data.errors.forEach( _ => {
            const lineNum = _.lineNumber;
            const errorMsgArr = [];
             _.errors.forEach(erObj => {
              errorMsgArr.push( erObj.field ? `<strong>${erObj.field}</strong>`: `${erObj.message} <br>` );
            });

            msgContent += '<br>Line ' + lineNum + ': ' + errorMsgArr.join(' ');
        });
        if(data?.Error){
          msgHeading = data?.Error;
        msgContent += `Error occurred while uploading userDirectory sheet!<br>Please try again.`;

       }
      } else if(status===0 && !data){
        msgContent += `Error occurred while uploading userDirectory sheet!<br>Please try again.`;
    }
      else {
        msgContent += `Error occurred while uploading userDirectory sheet!<br>Please fix the errors and re-upload.`;
      }

      setUploadFileStatusBlock("<p class='listErrorMessagesCls'>"+ msgHeading + "</p>" +
                                "<p class='listErrorMessagesCls sm-scrollbar border p-2 pt-1'>" + msgContent +"</p>"
                              );
    }
};

  let empProps = {
    onRemoveEmployee ,
    setRemove,
    setDelPop,
    setButtonDisable,
    onCloseDelete,
    delConf,
    remove,
    empSpec,
    userSelected
      },
       roleModalProps = {
        onRoleSubmit,
        onRoleChange,
        modalFormStatusObj,
        setRoleNames,
        subSelection,
        onChange,
        addRoles,
        setRoleOptions,
        roleOptions,
        onAddRole,
        isMoreDirectory,
        setRoleItems,
        roleNames
          },
      delProps = {
        setShow,
        show,
        buttonStat,
        onContinue,
        onCloseDelete,
          }
          console.log(state)
  return (
    <div className="op-aircraft-container ng-grid-right flexCol full-flex ag-theme-alpine-dark">

     {
       <>
        <div className='flexRow width100 margBot10 margTop8 justifyContentSpaceBetween'>
          {viewUserAcccntDetails?<div className=" flexRow justifyContentFlexEnd alignItemsBaseline">
                <button className='saleType-div m-2'>
                  <CustomSelect
                   options={userTypes}
                   placeHolder="Select User Type"
                   onChange={onUserChange}
                  />
                 </button>
          </div>:<></>}

          <div className="width100 flexRow justifyContentCenter alignItemsCenter">
    {viewUserAccnt? <div className="margBot10 underline">
            <span><img  className="icon-size" alt={t('filters.searchText')} src={searchIcon} /></span>
             <span><input className="search" onChange={onSearch} type="search" placeholder={t('filters.searchText')} value={searchKey}/></span>
            </div>:<></>}
            </div>
                    <div className='flexRow margTop8 justifyContentFlexEnd'>
          <div className="margLeft flexRow justifyContentFlexEnd alignItemsBaseline">
          {uploadUserAccnt?<button title={t('filters.uploadUserAccount')} className='upload dropdownStyle1-TextMedium' onClick={() => onUploadTaxMaster(true)}> <span><img  className="icon-size-min" alt='uploadItem' src={uploadItemIcon} /></span></button>:<></>}&nbsp;
              {downloadUserAccnt? <div className="flexRow justifyContentFlexStart margRight">

                      {isDownloading ? (
                               <button className="margRight">
                                    <img
                                      src={LoadingGIF}
                                      className="margBottom0 icon-size-min"
                                      alt="Loading"
                                    />
                                  </button>
                              ) : (

                                  <button
                                    disabled={isDownloading}
                                    className="margRight"
                                    style={{ cursor: 'pointer' }}
                                    title={t('filters.downloadUserAccounts')}
                                   onClick={onDownloadItemMaster}
                                  >
                                    <img src={DOWNLOAD_ICON} className="node-icon svg" alt="" />
                                  </button>
                                )
                              }

          </div>:<></>}

          </div>
        </div>
        <div className="flexRow justifyContentFlexEnd alignItemsCenter">
          {viewUserAccnt && deleteUserAccnt? <button disabled={buttonDisable} className="remove-button m-2 flex justifyContentCenter alignItemsCenter" onClick={ onRemoveEmployee }>
          <DeleteIcon className="icon-size removeEmpIcon" alt='deleteIcon' />
                  {t('buttons.removeEmployee')}
            </button>:<></>}
           {viewUserAccnt && createUserAccnt? <button style={{textWrap:"nowrap"}} className="add-emp-button m-2 flex justifyContentCenter alignItemsCenter" onClick={ onAddEmployeeHandler }>
                  {t('buttons.addUserAccnt')}
             </button>:<></>}
             </div>

        </div>
       {viewUserAccnt? <DataGrid
            className='full-flex'
            page="employee"
            ref={tableRef}
            columns={[...Columns]}
            initialPageLimit={perPageLimit}
            showDefaultFilters={false}
            searchKey={searchKey}
            selectAll={selectAll}
            {...empProps}
            columnResize={true}
            checkbox={checkbox}
            resetDataSource={state.resetDataSource}
            onAddEmployeeHandler={() => onAddEmployeeHandler()}
            getRows={fetchUserAccounts} />:<></>}
        </>
      }
      {
        state && Boolean(state.selected)&& Boolean(state.selected.action) && (
        <UpdateEmployeeModal
        type={state.selected.action==='editUserAccount'?"editUserAccount":'AddUserAccount'}
        title={state.selected.action==='editUserAccount'?"Update User":"Add User Account"}
        fields={state.selected.action==='editUserAccount'?editFormFields:AddEmployeeField.map((_) => {
              return { ..._, initialValue: "" }
              })}
            onChange={ (e, updated) => {
                      setModalFormStatusObj({text:""})
                  }}
        modalFormStatusObj={modalFormStatusObj}
        setModalFormStatusObj={setModalFormStatusObj}
        onSubmit={onEditSubmit}
        onClose={onClose}/>
        )
      }
      <ToastContainer/>
       {delPop && <DeleteConf  {...delProps} modalFormStatusObj={modalFormStatusObj} description={t('pages.employeePop.delConfirmDialogue')} />}
       {
        roleModal &&
        <RoleModal
        modelTitle={'User Directories'}
        onRoleModalClose={onClose}
        fields={roleItems}
        {...roleModalProps}
        />
      }
       {
        showUpload &&
        <RoleModal
        onRoleModalClose={onClose}
        fields={roleItems}
         {...roleModalProps}
        modelTitle={'Upload User Accounts'}
        onDownloadSampleFile={onDownloadSampleFile}
        uploadedFile = { uploadedFile }
        onUploadFileChangeHandler = { (e) => onUploadFileChangeHandler(e) }
        uploadFileStatusBlock = { uploadFileStatusBlock }
        />
      }
      {
      !ready &&<div className='overlay_hide sub'></div>
      }
    </div>
  )
}